<template>
  <div  class="row align-items-top execucaoAtendimento">
    <div class="col-md-1 border-sm-top  striped-sm">
      OS: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ execucao.nr_sequencial }}
      </strong>
    </div>
    <div class="col-md-1 border-sm-top  striped-sm">
      {{ $t('Placa') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ execucao.nr_placa }}
      </strong>
    </div>  
          
    <div class="col-md-2 border-sm-top  striped-sm">
      {{ $t('Início Atendimento') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ dataAtendimento }}
      </strong>
    </div>
    <div class="col-md-2  striped-sm">
      {{ $t('Problema') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
      <strong v-if="execucao.nr_conjunto">{{ execucao.ds_conjunto }} </strong>
    </div>
    <div class="col-md-4  striped-sm">
      {{ $t('Serviço') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
      <strong v-if="execucao.nr_item_frota">{{ execucao.ds_item_frota }} </strong>
    </div>
    <div class="col-md-2 d-none striped-sm">
      {{ $t('Quantidade') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ parseFloat(execucao.qt_quantidade) | brNumFormat("0.000") }}
      </strong>
    </div>
    <div class="col-md-2 d-none striped-sm">
      {{ $t('Início') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ execucao.dt_inicio | formatDate("DD/MM/YYYY HH:mm") }}
      </strong>
    </div>
    <div class="col-md-2 text-right  striped-sm" v-if="exibeParar">
      <div class="d-block d-md-none mt-3"></div>
      <button class="btn btn-danger m-2" @click="validaModal(execucao.nr_sequencial)">
        <i class="fas fa-stop"></i> {{ $t('Encerrar OS') }}
      </button>
      <router-link class="btn btn-success m-2" :to="'os/' + execucao.nr_sequencial">
        <i class="fas fa-sign-out-alt"></i> {{ $t('Acessar OS') }}
      </router-link>
    </div>
    <modal-items @saveItem="parar" :os="execucao" @showModalItems="showModalItems = false"
      v-if="showModalItems"></modal-items>
  </div>
</template>

<script>
import ModalItems from './Modais/ModalItems'

export default {
  props: {
    execucao: {},
    frotaItems: {},
    exibeParar: {}
  },
  components: {
    ModalItems
  },
  data() {
    return { items: '', idConjunto: '', inputOptions: '', show: false, selectServico: '', ds_tipo: '', showModalItems: false, cod_item: ''}
  },
  methods: {
    preencheLista(nr_conjunto) {
      this.show = true
      const items = this.frotaItems
      var options = []

      items.forEach(item => {
        if (item.nr_seq_conjunto == nr_conjunto) {
          var label = item.ds_item
        } else {
          return false
        }
        // Item de serviço
        if (item.tipo) {
          label = `${label}`

          if (item.tipo.st_habilita_execucao) {
            delete (item.estoque)
            options.push({
              ...item,
              label: label
            })
            return true
          }
        }

      })
      this.items = options
      return options
    },
    parar(servicoNrSequencial) {
      this.showModalItems = false

      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {
          if(!servicoNrSequencial){
            this.cod_item = this.execucao.item.nr_seq_item
          } else {
            this.cod_item = servicoNrSequencial
          }

          const execucao = {
            id: this.execucao.id,
            nr_seq_os_item_update: this.cod_item,
            nr_seq_os_item: this.execucao.nr_seq_os_item,
            nr_seq_os: this.execucao.item.nr_seq_os.toString(),
            nr_os: this.execucao.item.nr_seq_os.toString(),
            nr_seq_clifor: tecnicoId,
            validaExt: false,
            obsExterna: ''
          }

          this.$store.dispatch('osItemExecucao/update', { data: execucao }).then(response => {
            this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi')
          }).catch(() => {
            this.$swal.fire({
              title: 'Oops!',
              text: 'Falha ao parar execução. Tente novamente.',
              icon: 'error'
            })

            return false
          })
        }
      })
    },

    finalizarOs() {
      if (!this.selectServico.nr_sequencial) {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Insira um serviço. Tente novamente.',
          icon: 'error'
        })
      } else {
        this.parar()
        this.show = false
      }
    },

    validaModal(nr_sequencial) {
      this.$router.push('os/' + nr_sequencial + '/osExterna')

      // if (this.execucao.item.os.tp_os != "M" || this.execucao.item.os.tp_os != "V") {
      // if (true) {
      //   this.preencheLista(nr_conjunto)
      //   this.showModalItems = true
      // } else {
      //   this.parar()
      // }
      

    }
  },
  computed: {

    dataAtendimento() {
      const data = this.execucao.dt_inicio
      const dia = data.substring(8, 10)
      const mes = data.substring(5, 7)
      const ano = data.substring(0, 4)
      const hora = data.substring(11, 13)
      const minutos = data.substring(14, 16)
      return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + minutos
    },
    bgBackground() {
      return true
    },
    getHoursSlaAtual (){
      const data = new Date(this.execucao.dt_inicio)
      const horaAt = data.getHours()
      const minAt = data.getMinutes()

      const sla = this.execucao.item.os.conjunto.hr_sla

      const horaSla = sla.substring(0,2)
      const minSla = sla.substring(3,5)

      return `${parseInt(horaAt) + parseInt(horaSla)}:${parseInt(minAt) + parseInt(minSla)}:00`
    }
  },
  created () {
  }
}
</script>